import type { Cart } from '@/modules/cart/domain/Cart';

const WEDDING_PATH = '/checkout/novios/';

export const isWeddingFlow = () => {
  return location.pathname.includes(WEDDING_PATH);
};

export const getWeddingID = () => {
  const path = window.location.pathname;
  const match = path.match(/\/checkout\/novios\/([^/]+)\//);
  return match ? match[1] : '';
};

export const isWeddingCart = (cart: Cart | null | undefined) => {
  return cart?.clubParisCodeType === 'WEDDING';
};
